import React, {useEffect, useState} from "react";
import {ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import UserService from "../../../services/UserService";
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Spinner from "reactjs-simple-spinner";
import UserRolesService from "../../../services/UserRolesService";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    icon: {
        verticalAlign: 'bottom',
        height: 20,
        width: 20,
    },
    details: {
        alignItems: 'center',
    },
    column: {
        flexBasis: '33.33%',
    },
    smallColumn: {
        flexBasis: '20.00%',
        margin: 2
    },
    bigColumn: {
        flexBasis: '60.00%',
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2),
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));

const Permissions = (props) => {

    const [roles, setRoles] = useState([]);
    const classes = useStyles();
    const [loading, setLoading] = useState(true);

    const managePermissions = (id, name) => {
        console.info(id + " + " + name);
        let role = {
            id: id,
            name: name
        };

        localStorage.setItem('role', JSON.stringify(role));
        props.history.push('/permissions');
    };

    useEffect(() => {
        setLoading(true);
        let r = []
        UserRolesService.getRoles()
            .then(res => {
                console.log("response: ", res.data);
                res.data.data.map((role, i) => {
                    if (role[0].name !== 'sysadmin') {
                        r.push(role)
                    }
                })
                console.log("roles: ", r)
                setRoles(r);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setRoles([])
                setLoading(false);
            });
    }, []);

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* Same as */}
            <ToastContainer/>

            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content"
                className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/settings"><a href><i className="fa fa-cog"/>&nbsp;Settings</a></Link>
                             &nbsp;|&nbsp;
                            <Link to="/roles"><a href><i className="fa fa-user"/>&nbsp;IAM Roles Management</a></Link>
                             &nbsp;|&nbsp;
                            <span className="upper-class">Manage Roles & Permissions</span>
                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <div className="content-panel">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Getting Data,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {!loading && (
                                        <>
                                            <div className={classes.root}>
                                                {roles.map((role, i) => (
                                                        <Accordion>
                                                            <AccordionSummary
                                                                expandIcon={<ExpandMoreIcon/>}
                                                                aria-controls="panel1c-content"
                                                                id="panel1c-header"
                                                            >
                                                                <div className={classes.bigColumn}>
                                                                    <Typography
                                                                        className={classes.heading}>{role[0].name}</Typography>
                                                                </div>
                                                                <div className={classes.bigColumn}>
                                                                    <Typography className={classes.secondaryHeading}>Assigned
                                                                        Permissions</Typography>
                                                                </div>
                                                                <div className={classes.smallColumn}>
                                                                    <Typography
                                                                        className={classes.secondaryHeading}>Manage</Typography>
                                                                </div>
                                                            </AccordionSummary>
                                                            <AccordionDetails className={classes.details}>
                                                                <div className={classes.smallColumn}/>
                                                                <div className={classes.bigColumn}>
                                                                    {role[0].permissions.map((permission, p) => (
                                                                        <>
                                                                            <Chip
                                                                                className={classes.smallColumn}
                                                                                key={p}
                                                                                label={permission.name}
                                                                                color="success"
                                                                            />

                                                                        </>

                                                                    ))}

                                                                </div>
                                                                <div className={clsx(classes.smallColumn, classes.helper)}>
                                                                    <Button
                                                                        onClick={() => managePermissions(role[0].id, role[0].name)}
                                                                        className="btn btn-sm btn-primary">
                                                                        &nbsp;Manage Permissions&nbsp;
                                                                        <i className="fa fa-lock"/>
                                                                    </Button>
                                                                </div>
                                                            </AccordionDetails>
                                                            <Divider/>
                                                            {/*<AccordionActions>*/}
                                                            {/*    <Button size="small">Cancel</Button>*/}
                                                            {/*    <Button size="small" color="primary">*/}
                                                            {/*        Save*/}
                                                            {/*    </Button>*/}
                                                            {/*</AccordionActions>*/}
                                                        </Accordion>
                                                    )
                                                )
                                                }
                                            </div>
                                        </>

                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Permissions;
